<template>

    <div class="contactform">
        <h3
            v-if="contactform.header !== ''"
            v-text="contactform.header"
        />

        <field
            v-for="field in contactform.fields"
            :key="'field-' + field.uuid"
            :field="field"
            v-model="values[field.uuid]"
        ></field>

        <antispamtype
            v-model="values['nname']"
        ></antispamtype>

        <div>
            <button
                class="btn btn-primary"
                @click="onSubmit"
                :disabled="!canSubmit"
            >
                {{ lang('all.opslaan') }}
            </button>
        </div>
    </div>

</template>

<script>

import Field from './Field';
import Antispamtype from './Types/Antispamtype';

export default {

    computed: {
        canSubmit() {
            return this.posting === false;
        },
    },

    components: {
        Antispamtype,
        Field,
    },

    data() {
        return {
            posting:false,
            values:{},
        }
    },

    methods: {
        onSubmit() {
            if (!this.canSubmit) {
                return;
            }

            this.posting = true;

            this.$inertia.post(this.route('contactforms.store', {uuid: this.contactform.uuid}), this.values, {
                onFinish: () => this.posting = false,
            });
        },

        seedValues() {
            let values = {nname:''};
            this.contactform.fields.forEach(field => {
                values[field.uuid] = field.default;
            });
            this.values = JSON.parse(JSON.stringify(values));
        },
    },

    mounted() {
        this.seedValues();
    },

    name:'ContactformContactform',

    props: {
        contactform: {
            type:Object,
            required:true,
        },
    },
}

</script>

<style>

.contactform > .ast {
    display:block;
    visibility:hidden;
    height:0;
}

</style>
